const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export async function fetchRadarHealth({ sourceMode = "preferred", refresh = false } = {}) {
  const params = new URLSearchParams({ sourceMode });
  if (refresh) {
    params.set("refresh", "true");
  }

  const response = await fetch(`${API_BASE}/api/weather/radar/health?${params.toString()}`);

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message || payload.error || `Radar health request failed (${response.status})`);
  }

  return response.json();
}
